/* Optional native recommendations; zero invented products or custom pricing. */
(function(){
  document.querySelectorAll('[data-garment-recommendations][hidden]').forEach(function(element){
    if(!window.fetch || !window.AbortController)return;
    async function load(){
      var controller=new AbortController(),timer=setTimeout(function(){controller.abort();},5000);
      try{
        var url=new URL(element.dataset.url,location.origin);if(url.origin!==location.origin)return;
        var response=await fetch(url,{credentials:'same-origin',signal:controller.signal});if(!response.ok)return;
        var parsed=new DOMParser().parseFromString(await response.text(),'text/html'),content=parsed.querySelector('[data-garment-recommendations]');
        if(content && content.querySelector('.pcard')){element.innerHTML=content.innerHTML;element.hidden=false;element.querySelectorAll('[data-reveal]').forEach(function(card){card.classList.add('in');});}
      }catch(_){}finally{clearTimeout(timer);}
    }
    if('IntersectionObserver' in window){var observer=new IntersectionObserver(function(entries){if(entries.some(function(entry){return entry.isIntersecting;})){observer.disconnect();load();}},{rootMargin:'300px'});element.hidden=false;element.style.minHeight='1px';observer.observe(element);}
    else load();
  });
})();
